import React, { useEffect, useState } from "react";
//import TiptapEditor from "components/Editor/TiptapEditor";
import style from "./MIQ101F1.module.scss";
import { postData } from "../../utils/TransactionUtil";

const MIQ101F1 = ({ qstnRespId }) => {
    const [posts, setPosts] = useState([]);
    const [qnaDtl, setQnaDtl] = useState(null);  // 초기 상태를 null로 설정

    const handleSave = (content) => {
        setPosts([...posts, { id: Date.now(), content }]);
    };

    useEffect(() => {
        // 데이터를 가져오는 함수 호출
        getQnaDtl();
    }, []);

    async function getQnaDtl() {
        const prop = {
            schQstnRespId: qstnRespId,
        };
        const res = await postData("/MIQ/getQnaDtl", prop);
        console.log(res);
        setQnaDtl(res);  // 데이터를 정상적으로 받아오면 상태 업데이트
    }

    // 로딩 페이지 입력 추후 변경 필요
    if (qnaDtl === null) {
        return <div>Loading...</div>;
    }

    return (
        <main className={style.main_wrap}>
            {/*<TiptapEditor*/}
            {/*    content={qnaDtl?.qstnRespCtn || ""}  // qnaDtl이 없을 경우 빈 문자열로 처리*/}
            {/*    onUpdate={handleSave}*/}
            {/*/>*/}

            <div className="mt-4">
                {posts.map((post) => (
                    <div key={post.id} className="p-4 border rounded mt-2">
                        <div dangerouslySetInnerHTML={{ __html: post.content }} />
                    </div>
                ))}
            </div>
        </main>
    );
};

export default MIQ101F1;
